/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_NewInputs */

const vi_expense_new = /** @type {(inputs: Expense_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm khoản chi`)
};

/**

* @param {Expense_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_new = /** @type {((inputs?: Expense_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_new(inputs)
});